module.exports = __webpack_public_path__ + "img/1729044485320-c07c0e1a-1806-425a-acfa-ed52405e25ab.jpeg.d6c8d8d0.webp";